import DatricRequests from '../datric.requests';
import { Integration, IntegrationType, UpdateIntegrationPayload } from '../../../models/integration.model';

const requests = new DatricRequests();

export async function getIntegrations(): Promise<Integration[]> {
	return requests.get('config/integrations');
}

export async function updateIntegration(type: IntegrationType, payload: UpdateIntegrationPayload): Promise<Integration> {
	return requests.put(`config/integrations/${type}`, payload);
}
